var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0793 38.5992L43.5188 2.96604C43.3266 1.7508 41.6965 1.46369 41.1211 2.55002L35.1445 13.7356L49.0793 38.5992ZM9.375 46.875L14.8523 14.4387C14.8921 14.2068 14.9945 13.9903 15.1485 13.8125C15.3025 13.6347 15.5022 13.5024 15.726 13.4299C15.9498 13.3575 16.1891 13.3477 16.4181 13.4016C16.6471 13.4555 16.857 13.571 17.025 13.7356L50.625 46.875L31.95 57.6457C31.3769 57.96 30.7339 58.1248 30.0803 58.1248C29.4267 58.1248 28.7836 57.96 28.2105 57.6457L9.375 46.875ZM24.5672 18.6246L28.8492 10.4754C28.9557 10.2661 29.118 10.0903 29.3182 9.96747C29.5184 9.84468 29.7487 9.77969 29.9836 9.77969C30.2185 9.77969 30.4487 9.84468 30.649 9.96747C30.8492 10.0903 31.0115 10.2661 31.118 10.4754L49.9418 44.0321L24.5672 18.6246Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.62bcdbb47e23761ee3b6e674e68a8ba5.svg";
export { ForwardRef as ReactComponent };